/* ============================================================
   NK — product-page behaviour that has to run client-side.
   Loaded from layout/theme.liquid as nk-default-pack.js.

   Part 1 (27 Sep 2026) — preselect the multi-pack.
     See claude/offer-decision-bogo-vs-pack-of-2-27-sep-2026.md
   Part 2 (28 Sep 2026) — rewrite the WhatsApp button as an ORDER.
     See claude/full-status-readout-28-sep-2026.md

   Both live in this one file on purpose: theme.liquid already
   loads it, so nothing else in the theme needs editing and both
   changes revert by restoring this single asset.
   ============================================================ */

/* ---------- Part 1 · preselect the multi-pack -----------------
   Why: Pack of 1 was preselected, so the default add-to-cart was
   Rs 1,799 (CAC ceiling Rs 989). Pack of 2 carries the free
   So Nysinn lotion and a CAC ceiling of Rs 2,013. Nobody is
   forced — only the path of least resistance changes.

   How: we do not duplicate the section's logic. We click the
   "best" option so the section's own pick() runs, which sets
   is-on, checks the input, updates qty, the displayed total,
   window.NKPack, and the sticky bar's price. Verified live:
   sticky goes Rs 1,799 -> Rs 3,598 on its own.

   No-ops safely when a product has only one pack (the gift
   product's own page, single-variant items).
   ------------------------------------------------------------ */
(function () {
  function preselect() {
    var roots = document.querySelectorAll('[id^="nkps-"]');
    for (var i = 0; i < roots.length; i++) {
      var best = roots[i].querySelector('.nkps__opt--best');
      if (best && !best.classList.contains('is-on')) {
        best.click();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preselect);
  } else {
    preselect();
  }

  // Theme editor re-renders the section without a page load.
  document.addEventListener('shopify:section:load', preselect);
})();


/* ---------- Part 2 · WhatsApp order message ------------------- */
/* Why: the button's prefill read "I have a question about …" and quoted the
   PACK OF 1 price while the sticky bar showed the Pack of 2 total. Both real
   checkout starts on 27/28 Sep abandoned BEFORE typing a name, phone or email,
   so no abandoned-checkout record was even created — WhatsApp is the path for
   people who will not fill a checkout form at all, and the ad set has already
   produced two WhatsApp messages, so the channel works.

   How: rewrite the href entirely, client-side, from whatever pack is selected.
   Reads the page rather than Liquid data attributes, so nk-whatsapp.liquid is
   untouched. Message shape approved 28 Sep: English, "Assalam o Alaikum" kept,
   asking for the four things a COD order needs in one message. */
(function () {
  'use strict';

  var GIFT = 'So Nysinn Body Lotion'; // only ever named on a pack of 2 or more

  function link() { return document.querySelector('a.nk-wa[href*="wa.me/"]'); }

  function phoneFrom(a) {
    var m = (a.getAttribute('href') || '').match(/wa\.me\/(\d+)/);
    return m ? m[1] : '';
  }

  function productTitle() {
    try {
      var p = window.ShopifyAnalytics && window.ShopifyAnalytics.meta
            && window.ShopifyAnalytics.meta.product;
      if (p && p.variants && p.variants[0] && p.variants[0].name) {
        // "Bright & Shine - Default Title" → drop the variant suffix
        return String(p.variants[0].name).split(' - ')[0];
      }
    } catch (e) { /* fall through to the heading */ }
    var h = document.querySelector('h1');
    return h ? h.textContent.trim() : '';
  }

  function selectedOption() {
    return document.querySelector('.nkps__opt.is-on')
        || document.querySelector('.nkps__opt--best')
        || null;
  }

  // Option text looks like:
  //   "MOST POPULAR · SAVE RS.850 ×2 FREE Pack of 2 Rs.3,598.00 So Nysinn…"
  // "Pack of N" is the only token that is reliably present and unambiguous.
  function packOf(el) {
    if (!el) { return null; }
    var m = (el.textContent || '').match(/Pack of\s*(\d+)/i);
    return m ? { label: 'Pack of ' + m[1], qty: parseInt(m[1], 10) } : null;
  }

  function priceText(el) {
    if (el) {
      var t = el.getAttribute('data-total');
      if (t) { return t; }
    }
    // No pack selector on this page: fall back to the sticky bar, which
    // sections/nk-sticky-cta.liquid already keeps in step with the selection.
    var p = document.querySelector('[data-nk-sticky-price]');
    return p ? p.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function build() {
    var a = link();
    if (!a) { return; }

    // Only rewrite on a product page. Elsewhere the section's own prefill stands.
    if (!document.querySelector('.nkps__opt') && !document.querySelector('[data-nk-sticky-price]')) {
      return;
    }

    var phone = phoneFrom(a);
    var title = productTitle();
    if (!phone || !title) { return; }

    var el    = selectedOption();
    var pack  = packOf(el);
    var price = priceText(el);

    var lines = [
      'Assalam o Alaikum NK Aesthetics 👋',
      '',
      "I'd like to order:",
      '',
      '🛍️ ' + title + (pack ? ' — ' + pack.label : '')
    ];

    if (price) { lines.push('💰 ' + price + ' (Cash on Delivery)'); }

    // The free lotion only comes with 2 or more. Never promise it on a single.
    if (pack && pack.qty >= 2) { lines.push('🎁 + FREE ' + GIFT); }

    lines.push(
      '',
      'Name:',
      'Full address:',
      'City:',
      'Phone:',
      '',
      "(Just fill these 4 lines and send — we'll confirm your order.)",
      '',
      location.origin + location.pathname
    );

    a.setAttribute(
      'href',
      'https://wa.me/' + phone + '?text=' + encodeURIComponent(lines.join('\n'))
    );

    var label = a.querySelector('.nk-wa__label');
    if (label && /^\s*chat\s*$/i.test(label.textContent)) { label.textContent = 'Order'; }
    a.setAttribute('aria-label', 'Order from NK Aesthetics on WhatsApp');
  }

  build();

  // The pack selector's own handler moves .is-on on click, so read after it.
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.nkps__opt')) {
      setTimeout(build, 0);
    }
  });

  // nk-default-pack.js clicks "Pack of 2" on load. If it ran before us the
  // click above was missed, so rebuild once the dust settles.
  window.addEventListener('load', function () { setTimeout(build, 150); });
})();
